import { Contact } from '@/components/pages/my-profile/Contact';
import { FC } from 'react';

const MyProfileContact: FC = () => {
  return <Contact />;
};

export default MyProfileContact;
